import React, {useState} from "react";
import { Modal, Text, Button, TwSelector as Selector, TwFileUpload as FileUpload, Link, Loader, Icon } from "@ui-component-library";
import { ContentContainer } from "./utils/utils";
import {ErrorModal} from "../../../../../modals";
export const UploadPdfStep = ({ handleNext, arbonicsData, updateCo2Deal }) =>{
    
    const [fileError, setFileError] = useState('');
    const [successText, setSuccessText] = useState('');

    const [file,setFile] = useState([]);
    const [isLoading,setIsLoading] = useState(false);
    const [errorModal,setErrorModal] = useState(false);
    const [isValid, setIsValid] = useState(null)
    
    const runValidation = async (uploadedFiles) => {
        const validated = await Promise.all(
        uploadedFiles.map(async (f) => {
            const valid = await validateFiles(f); 
            f.valid = valid
            return f;
        })
        );

        const allValid = validated.every((f) => f.valid);

        setFile(validated);
        setIsValid(validated.length === 0 ? undefined : allValid);

        return validated;
    };

    async function readFileAsync(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            
            reader.readAsText(file);
        });
    }

    const validateFiles = async(data) => {
        if (data.file.type !== "application/pdf"){
            setFileError("Detta verkar inte vara en PDF-fil")
        }
        const fileText = await Promise.resolve(readFileAsync(data.file))
        if (fileText.includes("PDF")) {
            setSuccessText("Du har laddat upp en korrekt fil");
            setFileError("");
            return true;
        }
        setFileError("Detta verkar inte vara en PDF-fil")

        return fileText.indexOf("PDF") != -1
    }

    const skipStep = () => {
         handleNext({arbonicsData: {  }});
    }

    const handleSubmit = async() => {
        setIsLoading(true);
        let propandPdf = {...arbonicsData,"pdfFile":file[0].file}
        
        if (propandPdf?.pdfFile){
            var formData = new FormData()
            formData.append('file',propandPdf.pdfFile)
            formData.append('stage','pdf')
            formData.append('comments', 'Not sent, only finished step 3')

            const response = await updateCo2Deal(formData, false)
            handleNext({
                data:{
                    pdf_data:formData
                },
            });
            setIsLoading(false)
        }
        else{
            setIsLoading(false)
            setErrorModal(true)
        }
    }

     if (isLoading) {
        return (
       <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", width: "100%", flexDirection: "column", gap: "8px", }} >
            <Text variant="text-base/leading-none/normal">Bearbetar din fil... </Text>
            <Loader />
        </div>
        );
      }
    return (
    <>
        <Modal.Content>
            <ContentContainer>
                <>
                    <Text variant="text-base/leading-none/semibold">Vald fastighet</Text>
                    <Selector>
                        {[
                            {
                                label: arbonicsData.selectedProp.designation,
                                value: arbonicsData.selectedProp.ref
                            },
                        ].map((option) => (<Selector.Option
                            onClick={() => { }}
                            {...option}
                            key={option.value}
                            isSelected={option.value} />))
                        }
                    </Selector>
                    <Text variant="text-base/leading-none/semibold">Ladda upp skogsbruksplan</Text>
                    <Text variant="text-sm/leading-normal/medium" className="neutral-pebble">För att vi ska kunna analysera fastighetens potential behöver du ladda upp en skogsbruksplan i PDF-format. Filen får bara innehålla en fastighet för att analysen ska bli korrekt.</Text>
                    <FileUpload
                        accept=".pdf"
                        buttonText="Ladda upp pdf"
                        errorText={fileError}
                        successText={successText}
                        label="Filer som stöds: PDF"
                        onChange={runValidation}
                        value={file}
                        isValid={isValid} />
                </>
            </ContentContainer>
        </Modal.Content>
        <Modal.Footer>
            <>
                <div className="flex justify-between w-full">
                    <Button
                        variant="secondary"
                        onClick={skipStep}
                        disabled={''}
                    >Jag har ingen skogsbruksplan</Button>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={successText == "Du har laddat upp en korrekt fil" ? false : true}
                    ><React.Fragment key=".0">
                        Nästa steg 
                        <Icon
                            color={successText == "Du har laddat upp en korrekt fil" ?"white-500":"charcoal-500"}
                            name="ArrowRightSimple"
                        />
                        </React.Fragment>
                    </Button>
                </div>
            </>
        </Modal.Footer>
        <ErrorModal show={errorModal} title={errorModal?.title} message={errorModal?.message} onToggle={() => setErrorModal(false)} />
    </>
    );
};